var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoRecorderMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 15.1538V16C17 17.6569 15.6569 19 14 19H5C3.34315 19 2 17.6569 2 16V8C2 6.34315 3.34315 5 5 5H14C15.6569 5 17 6.34315 17 8V8.84615L18.7806 7.47648C20.0958 6.46476 22 7.40238 22 9.06173V14.9383C22 16.5976 20.0958 17.5352 18.7806 16.5235L17 15.1538ZM5 6.5H14C14.8284 6.5 15.5 7.17157 15.5 8V16C15.5 16.8284 14.8284 17.5 14 17.5H5C4.17157 17.5 3.5 16.8284 3.5 16V8C3.5 7.17157 4.17157 6.5 5 6.5ZM17 13.2614L19.6951 15.3346C20.024 15.5875 20.5 15.3531 20.5 14.9383V9.06173C20.5 8.64689 20.024 8.41248 19.6951 8.66541L17 10.7386V13.2614Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoRecorderMedium);
export default __webpack_public_path__ + "static/media/video_recorder_medium.856a077660ab4d976481ef1d0c87a915.svg";
export { ForwardRef as ReactComponent };